import React from 'react';

export const OptionTypeSelector = ({ selectedType, onTypeChange }) => {
  return (
    <div className="mb-6">
      <div className="flex rounded-lg overflow-hidden border border-gray-600">
        <button
          onClick={() => onTypeChange('call')}
          className={`flex-1 py-3 px-6 font-bold text-lg transition-all duration-200 ${
            selectedType === 'call'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          }`}
        >
          CALL
        </button>
        <button
          onClick={() => onTypeChange('put')}
          className={`flex-1 py-3 px-6 font-bold text-lg transition-all duration-200 ${
            selectedType === 'put'
              ? 'bg-red-600 text-white'
              : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          }`}
        >
          PUT
        </button>
      </div>
    </div>
  );
};
